import React, { useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const ImageVideoSlider = ({ Bild_oder_Video = "Bild", images, videoThumbnail, video, navSlider, sectionColor = "orange", moduleColor }) => {
    const settings = {
        dots: !navSlider ? true : false,
        arrows: navSlider ? true : false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
    };

    const videoRef = useRef(null);
    const [play, setPlay] = useState(false);

    const playVideo = () => {
        setPlay(true);
    }

    const pauseVideo = () => {
        setPlay(false);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovering, setHovering] = useState(false);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    return (
        <div className='slider_wrapper imgvideo_slider' style={{ paddingBottom: images?.length === 1 || Bild_oder_Video === "Video" ? 'unset' : '70px' }} >
            {Bild_oder_Video === "Bild" ? (
                <Slider {...settings}>
                    {images?.map((image, index) => (
                        <div key={index} className='slider_slide_item'>
                            <img src={`https://backend.bgzurlinden.ch${image?.url}`} className='w-100' alt='#' />
                        </div>
                    ))}
                </Slider>
            ) : (
                <div className={`video_thumbnail position-relative ${hovering && play ? 'hide_cursor' : ''}`} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} onMouseMove={mouseMove}>

                    {play && <video
                        ref={videoRef}
                        className="w-100 d-block pb-0"
                        // controls
                        autoPlay
                        playsInline
                        preload="metadata"
                        onClick={pauseVideo}
                        onEnded={pauseVideo}
                    >
                        <source
                            src={`https://backend.bgzurlinden.ch${video?.url}`}
                            type="video/mp4"
                        />
                    </video>}

                    {hovering && play && (
                        <div
                            className="video_image_cursor"
                            style={{
                                left: `${position.x}px`,
                                top: `${position.y}px`,
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                <path d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z" fill={`var(--${moduleColor ? moduleColor?.split(" ")[0] : sectionColor})`} fill-opacity="1" />
                                <rect x="47" y="38" width="8" height="45" fill="white" />
                                <rect x="66" y="38" width="8" height="45" fill="white" />
                            </svg>
                        </div>
                    )}

                    {!play && (
                        <>
                            <img
                                src={`https://backend.bgzurlinden.ch${videoThumbnail?.url}`}
                                alt=''
                                className='video_overlay_img'
                            />

                            <button
                                type='button'
                                onClick={playVideo}
                                className='video_play_btn'
                            >
                                <svg className='icon_play' xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                    <circle cx="60" cy="60" r="60" fill={`var(--${moduleColor ? moduleColor?.split(" ")[0] : sectionColor})`} />
                                    <path d="M83 60L43 83L43 37L83 60Z" fill="white" />
                                </svg>
                            </button>
                        </>
                    )}

                </div>
            )}
        </div>
    )
}

export default ImageVideoSlider